/**
  @version 1.0.0
  @created 2025-06-23
  @description Client-side document configuration for Next.js
*/

// react, nextjs
import { useRouter } from "next/router";
import type { AppProps } from "next/app";
import { addCollection } from "@iconify/react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
// Components ( HeroUI )
import { HeroUIProvider } from "@heroui/system";
// Components
import { ToastContainer } from "@/components/toast";
import { icons as solarIcons } from "@iconify-json/solar";
// Sources
import { fontSans, fontMono } from "@/source/styles/fonts";
// configs
import "@/source/styles/globals.css";

addCollection(solarIcons);

export const fonts = {
  sans: fontSans.style.fontFamily,
  mono: fontMono.style.fontFamily,
};

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();

  return (
    <HeroUIProvider navigate={router.push} locale="ko-KR">
      <ToastContainer />
      <NextThemesProvider attribute="class" defaultTheme="light" enableSystem={false}>
        <Component {...pageProps} />
      </NextThemesProvider>
    </HeroUIProvider>
  );
}
